import { useState, useRef, useEffect } from "react";
import "./UserMenu.css";

const getInitials = (name) => {
  if (!name) return "U";
  return name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
};

export default function UserMenu({ user, items = [], onLogout }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="wc-usermenu" ref={ref}>
      <div className="wc-usermenu-avatar" onClick={() => setOpen(o => !o)} title={user.name}>
        {getInitials(user.name)}
      </div>
      {open && (
        <div className="wc-usermenu-dropdown">
          <div className="wc-usermenu-info">
            <div className="wc-usermenu-avatar wc-usermenu-avatar-lg">{getInitials(user.name)}</div>
            <div>
              <p className="wc-usermenu-name">{user.name}</p>
              <p className="wc-usermenu-email">{user.email}</p>
            </div>
          </div>
          <div className="wc-usermenu-divider" />
          {items.map((item, i) => (
            <button
              key={i}
              className="wc-usermenu-item"
              onClick={() => { item.onClick(); setOpen(false); }}
            >
              <span>{item.icon}</span> {item.label}
            </button>
          ))}
          <div className="wc-usermenu-divider" />
          <button
            className="wc-usermenu-item wc-usermenu-logout"
            onClick={() => { onLogout(); setOpen(false); }}
          >
            <span>🚪</span> Log Out
          </button>
        </div>
      )}
    </div>
  );
}
